import { CContainedButton } from 'components/atoms';
import { useRouteError, isRouteErrorResponse } from 'react-router-dom';

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <div className="flex h-screen w-full flex-col items-center justify-center gap-8 text-xl">
      <h1 className="text-4xl font-bold">Oops!</h1>

      {isRouteErrorResponse(error) ? (
        <>
          <p>{error.error?.message || 'Sorry, an unexpected error has occurred.'}</p>

          <p className="text-primary-200">
            <i>
              {error?.status} - {error?.statusText || error.error?.message}
            </i>
          </p>
        </>
      ) : (
        <p>Sorry, an unexpected error has occurred.</p>
      )}

      <CContainedButton onClick={() => (window.location.href = '/')}>
        Click here to reload the app
      </CContainedButton>
    </div>
  );
}
